// eslint-disable-next-line no-unused-vars
import { h } from 'preact';
import Result from './Result';

const ResultList = ({ entries = [], types = [] }) => (
  <div className="search-modal-results-list">
    {entries.map((entry) => (
      <Result key={entry.id} entry={entry} types={types} />
    ))}
  </div>
);

export default ResultList;
